export const STALE_TIMES = {
  DEFAULT: 60_000,
  AUTH: 30_000,
  CATEGORIES: 5 * 60_000,
  PRODUCTS: 60_000,
  DICTIONARY: 5 * 60_000,
  SETTINGS: 5 * 60_000,
  PICKUP_POINTS: 5 * 60_000,
  BANNERS: 60_000,
  FAVORITES: 60_000,
} as const;

export const GC_TIMES = {
  DEFAULT: 10 * 60_000,
  LONG: 30 * 60_000,
} as const;
